import { IonIcon } from "@ionic/react";
import { timeOutline } from "ionicons/icons";

interface ApplicationConfirmationItemProps {
  /** Date label (e.g., "ma 20 jan") */
  dateLabel: string;
  /** Month abbreviation (e.g., "jan") */
  month: string;
  /** Day of month (e.g., "20") */
  day: string;
  /** Year or weekday (e.g., "2024" or "ma") */
  yearOrWeekday: string;
  /** Project or slot title */
  title: string;
  /** Time range (e.g., "18:00 - 23:00") */
  timeRange: string;
}

/**
 * Simplified application item for confirmation modal. Shows date, title, and time in a clean layout
 * similar to ApplicationListItem but without status or menu options.
 */
export function ApplicationConfirmationItem({
  month,
  day,
  yearOrWeekday,
  title,
  timeRange,
}: ApplicationConfirmationItemProps) {
  return (
    <div className="flex gap-5 border-b border-bordercolor-primary pb-5">
      {/* Date box */}
      <div className="flex w-12 shrink-0 flex-col items-center px-1 py-2">
        <div className="flex flex-col items-center pb-0.5 text-center text-txt-primary">
          <p className="text-sm font-semibold leading-tight">{month}</p>
          <p className="text-2xl font-semibold leading-none">{day}</p>
        </div>
        <p className="text-sm font-medium text-txt-tertiary">{yearOrWeekday}</p>
      </div>

      {/* Application details */}
      <div className="flex flex-1 flex-col gap-3 py-2">
        <div className="flex flex-col gap-2">
          {title && (
            <span className="w-fit rounded-full bg-surface-brand-secondary px-2.5 py-1 text-xs font-semibold text-button-primary">
              {title}
            </span>
          )}

          {/* Metadata */}
          <div className="flex flex-col gap-2">
            {/* Time */}
            <div className="flex items-center gap-1.5">
              <IonIcon icon={timeOutline} className="text-base text-txt-tertiary" />
              <p className="text-base font-medium text-txt-tertiary">{timeRange}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
